<template>
    <div class="wrap" :class="{addPadding, 'toUser': showUser}">
      <car-headerbar :title="'设置'" />
       <CarsForm
          ref="demoDynamicForm"
          :configData="configData"
          :model="model"
          @submitAction="settingSave"
          @addEventListenerForInput="addEventListenerForInput"
          @removeEventListenerForInput="removeEventListenerForInput"
          @toUser="toUser"
          @input="handleInput"
      />
      <div class="white" v-if='showUser'></div>
      <me-popup v-model="showUser" position="bottom">
          <Seaarch @getUser="getUser"></Seaarch>
      </me-popup>
    </div>
  </template>
  
  <script>
  import CarsForm from 'imc-mobile/src/component/form'
  import { Questionnaire } from '@/network'
  import { Toast } from '@guazi-fe/melon'
  import { mixin } from '@/mixins'
  import browser from '@/util/browser'
  // import { off as offStatus } from '@/util/status-util'
  import debounce from '@/util/debounce'
  import { addClass2, removeClass2 } from '@/util/status-util'
  import Seaarch from '../compontents/search.vue'
  
  const dateFormat2 = (val) => {
      let dateVal
      if (val === '0' || !val) {
          // dateVal = new Date()
          return {
              value: '',
              text: '',
          }
      }
      val = Number(val)
      dateVal = new Date(val)
  
      let year = dateVal.getFullYear()
      let month = dateVal.getMonth() + 1
      let day = dateVal.getDate()
      let hour = dateVal.getHours()
      let minute = dateVal.getMinutes()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
      if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
      let timeText = `${year}-${month}-${day} ${hour}:${minute}`
  
      return {
          value: val,
          text: timeText,
      }
  }
  
  // dateFormat
  const dateFormat = (val) => {
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      let hour = val.getHours()
      let minute = val.getMinutes()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
      if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
      let timeText = `${year}-${month}-${day} ${hour}:${minute}`
  
      return {
          value: timeText,
          text: timeText,
      }
  }
  
  export default {
      data() {
          return {
              model: {
                  startTime: '',
                  endTime: '',
                  loginType: 'Anonymous',
                  limitType: 'Limit_No',
                  answerType: false,
                  endContent: '',
                  footer: 'chehaoduo',
                  toUser: '',
              },
              toUserColumn: [{
                  text: '未设置',
                  value: '0',
              }],
              addPadding: false,
              showUser: false,
              firstDefaultIndex: 0,
              secondDefaultIndex: 0,
          }
      },
      mixins: [mixin],
  
      components: {
          CarsForm,
          Seaarch,
      },
      created() {
          this.getQuestionConfig()
          
      },
      mounted() {
  
              
      },
      computed: {
          pageId() {
              return this.$route.params.pageId
          },
          limitObj() {
              return [this.realName]
          },
          anonymous() {
              return {
                  values: [
                      // {text: '', value: ''},
                      {text: '同一手机/电脑', value: 'Client'},
                      {text: '扩展字段1', value: 'ext1'},
                      {text: '扩展字段2', value: 'ext2'},
                      {text: '扩展字段3', value: 'ext3'},
                      {text: '扩展字段4', value: 'ext4'},
                  ],
                  defaultIndex: this.firstDefaultIndex,
              }
          },
          realName() {
              return {
                  values: [
                      {text: '不限制', value: 'All'},
                      {text: '只允许1次', value: 'Limit_1'},
                      {text: '只允许2次', value: 'Limit_2'},
                      {text: '只允许3次', value: 'Limit_3'},
                      {text: '每天只允许1次', value: 'Limit_Day1_1'},
                      {text: '每天只允许2次', value: 'Limit_Day1_2'},
                      {text: '每天只允许3次', value: 'Limit_Day1_3'},
                      {text: '7天内允许1次', value: 'Limit_Day7_1'},
                      {text: '7天内允许2次', value: 'Limit_Day7_2'},
                      {text: '7天内允许3次', value: 'Limit_Day7_3'},
                      {text: '30天内允许1次', value: 'Limit_Day30_1'},
                      {text: '30天内允许2次', value: 'Limit_Day30_2'},
                      {text: '30天内允许3次', value: 'Limit_Day30_3'},
                  ],
                  defaultIndex: this.secondDefaultIndex,
              }
          },
          configData() {
              return {
                  form: {
                      button: { disabled: false, text: '确定', api: 'submit' },
                      groupData: [
                          {
                              type: 'group', // 分组
                              label: '基础设置',
                              code: 'group1',
                              items: [
                                  {
                                      code: 'startTime',
                                      label: '开始时间',
                                      type: 'calendar',
                                      component: 'me-datetime-picker',
                                      placeholder: '未设置',
                                      itemProps: {
                                          column: 'horizontal',
                                          showType: 'popup',
                                      },
                                      props: {
                                          format: dateFormat,
                                          type: 'datetime',
                                          calendarType: 'me-datetime-picker',
                                          rightIcon: this.model.startTime ? 'cross' : 'arrow',
                                      },
                                  },
                                  {
                                      code: 'endTime',
                                      label: '结束时间',
                                      type: 'calendar',
                                      placeholder: '未设置',
                                      component: 'me-datetime-picker',
                                      itemProps: {
                                          column: 'horizontal',
                                          showType: 'popup',
                                      },
                                      props: {
                                          format: dateFormat,
                                          type: 'datetime',
                                          calendarType: 'me-datetime-picker',
                                          rightIcon:  this.model.endTime ? 'cross' : 'arrow',
                                      },
                                  },
                                  {
                                      code: 'loginType',
                                      label: '实名/匿名答卷',
                                      type: 'picker',
                                      placeholder: '匿名',
                                      props: {
                                          // readonly: true,
                                          columns: [{
                                              text: '实名',
                                              value: 'RealName',
                                          },
                                          {
                                              text: '匿名',
                                              value: 'Anonymous',
                                          },
                                          ],
                                          rightIcon: 'arrow',
                                      },
                                      itemProps: {
                                          column: 'horizontal',
                                          // readonly: true,
                                      },
                                  },
                                  {
                                      code: 'limitType',
                                      label: '答题次数限制',
                                      type: 'picker',
                                      placeholder: '不限制',
                                      props: {
                                          rightIcon: 'arrow',
                                          columns: this.model.loginType === 'Anonymous' ? [ this.anonymous, this.realName ] : [ this.realName ],
                                      },
                                      itemProps: {
                                          column: 'horizontal',
                                      },
                                  },
                                  {
                                      code: 'answerType',
                                      label: '只能通过呱呱（移动端）答题',
                                      type: 'switch',
                                      props: {
                                          // disabled: true
                                      },
                                      itemProps: {
                                          column: 'horizontal',
                                      },
                                  },
                              ],
                          },
                          {
                              type: 'group', // 分组
                              label: '提交后显示',
                              code: 'group2',
                              items: [
                                  {
                                      code: 'endContent',
                                      label: '结束语',
                                      type: 'textarea',
                                      rules: [{ required: true, message: '请填写结束语' }],
                                      props: {
                                          rows: 2,
                                          // maxlength: '500',
                                          // showWordLimit: true,
                                      },
                                  },
                              ],
                          },
                          {
                              type: 'group', // 分组
                              label: '外观',
                              code: 'group2',
                              items: [
                                  {
                                      code: 'footer',
                                      label: 'LOGO设置',
                                      type: 'picker',
                                      placeholder: '车好多',
                                      props: {
                                          rightIcon: 'arrow',
                                          columns: [{
                                              text: '企业中台中心',
                                              value: 'eim',
                                          },
                                          {
                                              text: '车好多',
                                              value: 'chehaoduo',
                                          },],
                                      },
                                      itemProps: {
                                          column: 'horizontal',
                                      },
                                  },
                              ],
                          },
                          {
                              type: 'group', // 分组
                              label: '其他',
                              code: 'group2',
                              items: [
                                  {
                                      code: 'pageId',
                                      label: `问卷ID：${this.$route.params.pageId}`,
                                      type: 'cell',
                                      placeholder: '',
                                      itemProps: {
                                          column: 'horizontal',
                                      },
                                  },
                                  {
                                      code: 'toUser',
                                      label: '转移他人',
                                      type: 'picker',
                                      placeholder: '未设置',
                                      props: {
                                          readonly: true,
                                          rightIcon: 'arrow',
                                          columns: this.toUserColumn,
                                      },
                                      itemProps: {
                                          column: 'horizontal',
                                      },
                                  },
                              ],
                          },
                      ],
                  },
                  api: {
                      request: {
                          submit: {
                              url: '',
                              method: 'post',
                          },
                      },
                  },
              }
          }
      },
      methods: {
          handleInput(val, code) {
              /endTime|startTime/.test(code) ? this.model[code] = val : null
              if (/Anonymous|RealName/.test(val)) {
                  this.model.loginType = val
                  this.model.limitType = val === 'Anonymous' ? '┇All' : 'Limit_No'
                  this.firstDefaultIndex = 0
                  this.secondDefaultIndex = 0
              }
              if (/limitType/.test(code)) this.model.limitType = val
              if (/answerType/.test(code)) this.model.answerType = val
          },
          toUser() {
              this.showUser = true
          },
          getUser(user) {
              this.showUser = false
              this.toUserColumn.splice(1, 1, {value: user.employeeCode, text: user.employeeName})
              this.model = {...this.model, toUser: user.employeeCode}
          },
          // 移动端输入时键盘弹起
          addEventListenerForInput() {
              const isAndroid = /android/i.test(window.navigator.userAgent)
              isAndroid ? this.addPadding = true : null
          },
          removeEventListenerForInput() {
              const isAndroid = /android/i.test(window.navigator.userAgent)
              isAndroid ? this.addPadding = false : null
          },
          settingSave: debounce(function (res) {
              const data = {
                  tid: this.tid,
                  pageId: this.pageId,
              }
              if (res) {
                  res.answerType = res.answerType ? 'guagua' : ''
                  if (res.startTime && typeof (res.startTime) === 'string') {
                      if (res.startTime.indexOf('-') > -1) {
                          res.startTime = res.startTime.replace(/-/g, '/')
                      }
                  }
                  if (res.endTime && typeof (res.endTime) === 'string') {
                      if (res.endTime.indexOf('-') > -1) {
                          res.endTime = res.endTime.replace(/-/g, '/')
                      }
                  }
                  res.startTime = res.startTime ? new Date(res.startTime).getTime() : ''
                  res.endTime = res.endTime ? new Date(res.endTime).getTime() : ''
                  if (res.startTime && res.endTime) {
                      if (res.endTime < res.startTime) {
                           Toast.fail('结束时间不能小于开始时间')
                           return
                      }
                  }
              }
              addClass2('body', 'loading')
              // 转移他人
              const toUser = this.model.toUser
              toUser ? this.transfer(toUser) : null
              // 员工答题次数限制
              let { limitType } = res
              Array.isArray(limitType) ? res.limitType = limitType.map(item => item && item.value).join('┇') : null
  
              const ajaxData = Object.assign(res, data)
              Questionnaire.questionConfig(ajaxData).then((res) => {
                  const { code } = res.data
                  if (code == 'S00000') {
                      if (toUser) return
                      Toast.success('保存成功')
                      const { guaguaApp } = browser
                      if (guaguaApp) {
                          $CA.util.NativeAPI.invoke('closeCurrentWebView', null, () => {})
                      } else {
                          this.$router.push({
                              name: 'edit',
                              params: {
                                  pageId: this.pageId,
                              },
                          })
                      }
                  }
              }).catch((error) => {
                  console.log(error.response)
                  removeClass2('body', 'loading')
                  Toast.fail(error.response.data.message)
              })
          }, 800),
          transfer(toUser) {
              const data = {
                  toUser,
                  tid: this.tid,
                  pageId: this.pageId,
              }
              Questionnaire.transfer(data).then(() => {
                  Toast.success('保存且转移成功')
                  this.$router.replace('/index')
              })
          },
          getQuestionConfig() {
              addClass2('body', 'loading')
              const data = {
                  tid: this.tid,
                  pageId: this.pageId,
              }
              Questionnaire.getQuestionConfig(data).then((res) => {
                  const { code, data } = res.data
                  removeClass2('body', 'loading')
                  if (code == 'S00000') {
                      const formatData = {
                          answerType: data.answerType == 'guagua',
                          startTime: dateFormat2(data.startTime).text,
                          endTime: dateFormat2(data.endTime).text,
                          // startTime: data.startTime,
                          // endTime: data.endTime,
                          loginType: data.loginType,
                          limitType: data.limitType,
                          endContent: data.endContent,
                          footer: data.footer,
                          toUser: data.toUser || '',
                      }
                      if (data.loginType === 'Anonymous') {
                          let [first, second] = data.limitType.split('┇')
                          let firstObj = this.anonymous.values.find(item => item.value === first)
                          let secondObj = this.realName.values.find(item => item.value === second)
                          formatData.limitType = [firstObj, secondObj]
                          this.firstDefaultIndex = this.anonymous.values.findIndex(item => item.value === first)
                          this.secondDefaultIndex = this.realName.values.findIndex(item => item.value === second)
                      }
                      this.model = formatData
                  }
              }).catch((error) => {
                  removeClass2('body', 'loading')
                  console.log(error.response)
                  Toast.fail(error.response.data.message)
              })
          },
      },
     
  }
  </script>
  <style lang="scss" scoped>
      .addPadding {
          padding-bottom: 400PX!important;
      }
      .wrap{
          position: relative;
          // background: #F2F4F6;
          height: 100%;
      }
      ::v-deep .dynamic-form-container{
          padding: 0;
          background: #F2F4F6;
          min-height: 100vh;
          .me-form-group-head{
              height: 44px;
              background: #F2F4F6;
          }
          .me-form-group {
            background: #fff;;
            .me-form-group-head {
              padding: 0 12px;
              .me-form-group-head__title {
                height: 43px;
                line-height: 43px;
              }
            }
          }
          .me-field__control_gray {
              .me-field__control{
                  color: #bec5cf;
              }
          }
          .me-form > div:first-child {
          //   height: calc(100% - 50px);
            padding-bottom: 150px;
          //   overflow-y: scroll;
          }
  
          .dynamic-form-fielditem{
              .me-cell{
                padding: 0 22px;
                line-height: 52px;
              }
              .me-cell__title{
                  font-size: 14px;
                  color:#222;
                  margin-bottom: 0 !important;
              }
  
              .me-field__body{
                    textarea {
                        background: #F6F6F6;
                        line-height: 36px;
                        border-radius: 6px;
                        padding-left: 16px ;
                    }
                  .me-field__control--custom{
                    justify-content: flex-end;
                  }
              }
              .me-field--min-height .me-field__control{
                  min-height: 36px;
              }
          }
          .dynamic-form-fielditem-horizontal .me-cell__value{
              display: flex;
              justify-content: flex-end;
          }
          .me-switch--on{
              background: #06B455;
          }
          .dynamic-form-footer{
              .me-button--primary{
                  background: #06B455;
              }
          }
      }
      ::v-deep .me-form-group:nth-child(2){
          padding-bottom: .48rem;
      }
      ::v-deep .dynamic-form-container .dynamic-form-fielditem::after{
          border: none!important;
      }
      .toUser ::v-deep .me-popup--bottom{
          padding: 16px;
          height: 80%;
          box-sizing: border-box;
      }
      ::v-deep .me-field__body{
          width: 100%;
      }
      .white{
          z-index: 1!important;
          background: #fff!important;
          position: fixed;
          width: 100%;
          height: 80%;
          left: 0;
          bottom: 0;
      }
  </style>
  